import { render, staticRenderFns } from "./CallCentreDashboard.vue?vue&type=template&id=0bd66576&scoped=true"
import script from "./CallCentreDashboard.vue?vue&type=script&lang=ts"
export * from "./CallCentreDashboard.vue?vue&type=script&lang=ts"
import style0 from "./CallCentreDashboard.vue?vue&type=style&index=0&id=0bd66576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd66576",
  null
  
)

export default component.exports